
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"57","height":"55","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2500_36470)","stroke":"#FBBB48","stroke-width":"2.474","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M27.121 24.914c6.203 0 11.231-5.07 11.231-11.322 0-6.253-5.028-11.321-11.23-11.321-6.203 0-11.231 5.068-11.231 11.321s5.028 11.322 11.23 11.322zM13.055 48.884c6.203 0 11.23-5.069 11.23-11.321 0-6.253-5.027-11.322-11.23-11.322s-11.23 5.07-11.23 11.322c0 6.252 5.027 11.321 11.23 11.321zM41.188 48.884c6.202 0 11.23-5.069 11.23-11.321 0-6.253-5.028-11.322-11.23-11.322-6.203 0-11.231 5.07-11.231 11.322 0 6.252 5.028 11.321 11.23 11.321z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2500_36470"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h56v55H0z"}})])])])
          )
        }
      }
    